export default __webpack_public_path__ + "static/media/cert-finance-consumer-sc.a6616870.jpg";